import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseApiService } from '../base-api.service';
import { AccountService } from '../account.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ObrtniciReportingService {
  constructor(
    private api: BaseApiService,
    private accountService: AccountService,
  ) { }

  kpr1041(params) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'hr-HR',
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}obrtnici-reporting/kpr-1041`,
      {
        od: params.od,
        do: params.do,
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
}
